import styled from '@emotion/styled';
import { css } from '@emotion/react';

import COLORS3 from '../../styles/emotion/colors3';
import MEDIA_QUERY_V2 from '../../styles/emotion/mediaQueryV2';

export type GridViewportProps = {
  rows?: string;
  columns?: string;
  gap?: string | number;
  bordered?: boolean;
};

export type GridMediaQueries = {
  mobile?: GridViewportProps;
  tablet?: GridViewportProps;
  desktop?: GridViewportProps;
  desktopMd?: GridViewportProps;
  desktopLg?: GridViewportProps;
  desktopXl?: GridViewportProps;
};

export type GridProps = GridViewportProps & {
  mediaQueries?: GridMediaQueries;
};

const GridPropsFactory = (props: GridViewportProps | undefined) => {
  if (!props) return '';
  const { rows, columns, gap, bordered } = props;
  return css`
    ${rows && `grid-template-rows: ${rows};`}
    ${columns && `grid-template-columns: ${columns};`}
    ${gap ? `grid-gap: ${typeof gap === 'string' ? gap : `${gap}px`};` : ''}
    ${bordered === false
      ? `
      border: unset;
      & > * {
        border: unset;
      }
    `
      : `
      border-top: 1px solid ${COLORS3.BLACK_030};
      border-left: 1px solid ${COLORS3.BLACK_030};
      & > * {
        border-bottom: 1px solid ${COLORS3.BLACK_030};
        border-right: 1px solid ${COLORS3.BLACK_030};
      }
    `}
  `;
};

export const Grid = styled.div<GridProps>`
  display: grid;
  ${({ rows = '1fr', columns = '1fr', gap = 0, bordered = true }) =>
    GridPropsFactory({ rows, columns, gap, bordered })}
  ${({ mediaQueries }) => css`
    ${MEDIA_QUERY_V2.MOBILE} {
      ${GridPropsFactory(mediaQueries?.mobile)}
    }
    ${MEDIA_QUERY_V2.TABLET} {
      ${GridPropsFactory(mediaQueries?.tablet)}
    }
    ${MEDIA_QUERY_V2.DESKTOP} {
      ${GridPropsFactory(mediaQueries?.desktop)}
    }
    ${MEDIA_QUERY_V2.DESKTOP_LG} {
      ${GridPropsFactory(mediaQueries?.desktopMd)}
    }
    ${MEDIA_QUERY_V2.DESKTOP_XL} {
      ${GridPropsFactory(mediaQueries?.desktopLg)}
    }
    ${MEDIA_QUERY_V2.DESKTOP_MASSIVE} {
      ${GridPropsFactory(mediaQueries?.desktopXl)}
    }
  `}
`;
